import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, FormControl, PatternValidator } from '@angular/forms';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { CreditNoteModel } from '../../../models/consultation/cash-sale.model';
import { isNumber } from 'util';
import { CreditNoteService } from './credit-note-popup.service';
@Component({
  selector: 'add-credit-note-popup',
  templateUrl: 'credit-note-popup.component.html',
  providers: [CreditNoteService]
})
export class CreditNotePopupComponent implements OnInit {
  creditNoteForm: FormGroup;
  creditNoteModel = new CreditNoteModel();
  regex = '\\d*\\.?\\d{1,2}';
  validAmount = 0;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public creditNoteService: CreditNoteService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<CreditNotePopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
  ) {
    this.createForm();
  }

  ngOnInit() {
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  createForm() {
    this.creditNoteForm = this.formBuilder.group({
      note: ['', [Validators.required]],
      amount: ['', [Validators.required]],
    });
  }

  // funciton numeric characters only with 2 decimal places
  onKeyUpAmount(event) {
    const value = event.target.value;
    if (value) {
      const str = value.toString().split('.')[1];
      if (str && str.length > 2) {
        this.creditNoteForm.controls['amount'].setValue(parseFloat(value).toFixed(2));
      }
      this.validAmount = this.creditNoteForm.controls['amount'].value;
    } else if (this.validAmount !== 0) {
      this.creditNoteForm.controls['amount'].setValue(this.validAmount);
    }
  }

  // save
  onSubmit() {
    if (this.creditNoteForm.dirty && this.creditNoteForm.valid) {
      // change value
      const creditNote = {
        note: this.creditNoteForm.value.note,
        amount: this.creditNoteForm.value.amount,
        currencyCode: this.data.currency.code
      }
      // call API to create credit note
      this.creditNoteService.saveCreditNote(creditNote, this.data.consultationId, this.data.invoiceId).subscribe(
        (result) => {
          if (result) {
            this.dialogRef.close(result.json());
          }
        }
      )
    };
    //
    /*   this.dialogService.openSuccessDialog({
        message: AppMessages.dialog.successTitle
      }); */
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/credit-note-popup.component.ts